/**
 * Firebase initialization and configuration
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

let firebaseApp = null;
let auth = null;
let db = null;
let storage = null;
let isInitialized = false;

/**
 * Initialize Firebase with configuration
 */
export async function initFirebase() {
  try {
    // Firebase configuration will be loaded from environment variables
    const firebaseConfig = {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
    };

    // Check if Firebase config is valid
    if (!firebaseConfig.apiKey || firebaseConfig.apiKey === 'demo-api-key') {
      console.warn(
        'Firebase not configured. Using demo mode. Update .env file with real Firebase credentials.'
      );
      isInitialized = false;
      return;
    }

    // Initialize Firebase
    firebaseApp = initializeApp(firebaseConfig);
    auth = getAuth(firebaseApp);
    db = getFirestore(firebaseApp);
    storage = getStorage(firebaseApp);
    isInitialized = true;

    console.log('Firebase initialized successfully');
  } catch (error) {
    console.error('Firebase initialization error:', error);
    isInitialized = false;
  }
}

/**
 * Check if Firebase is initialized
 */
export function isFirebaseInitialized() {
  return isInitialized;
}

/**
 * Get Firebase Auth instance
 */
export function getAuthInstance() {
  if (!auth || !isInitialized) {
    throw new Error(
      'Firebase not initialized. Please configure Firebase in .env file and restart the app.'
    );
  }
  return auth;
}

/**
 * Get Firestore instance
 */
export function getFirestoreInstance() {
  if (!db || !isInitialized) {
    throw new Error(
      'Firebase not initialized. Please configure Firebase in .env file and restart the app.'
    );
  }
  return db;
}


/**
 * Get Firebase Storage instance
 */
export function getStorageInstance() {
  if (!storage || !isInitialized) {
    throw new Error(
      'Firebase not initialized. Please configure Firebase in .env file and restart the app.'
    );
  }
  return storage;
}
